import React, { useState, useEffect, useRef, useMemo } from "react";
import moment from "moment";

// components
import NavDashboard from "../../components/NavDashboard";
import ReactApexChart from "react-apexcharts";
import * as XLSX from 'xlsx';
import { convertCurrency, covertTimeZone, numberFormat, NewCovertTimeZone } from "../../helper";

// apollo-client
import {
  GET_ALL_SUM_ORDER_V2,
  GET_REPORT_BEST_SALE_V2,
} from "../../apollo/exchangeRate/Query";
import { useLazyQuery } from "@apollo/client";
import "./index.css";

// react-icons
import LocalActivityIcon from "@mui/icons-material/LocalActivity";

// react bootrap
import { Table, Card, Spinner, Button, Form, Col, Row } from "react-bootstrap";
import { AiOutlineFileText, AiOutlinePieChart } from "react-icons/ai";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { MdOutlineDateRange } from "react-icons/md";
import { ConvertDay, startDateAndEndDate } from "../../components/handleDate";
import AnimationLoading from "../../components/Animationloading";
import EmptyComponent from "../../components/EmptyComponent";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactToPrint from "react-to-print";
import CurrentDateComponents from "../../components/CurrentDateComponents";
import _ from "lodash";
import { GET_BRANDS } from "../../apollo/brand/Query";
import { GET_CATEGORYS } from "../../apollo/category/query";

function Dashboard() {
  const currentBrand = localStorage.getItem("CURRENT_BRAND");
  const [reportSumAllOrder, setReportSumAllOrder] = useState();
  const [reportBestSale, setReportBestSale] = useState([]);
  let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const printRef = useRef();
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [searchBrand, setSearchBrand] = useState(currentBrand);
  const [categories, setCategories] = useState([]);
  const [searchCategory, setSearchCategory] = useState("ALL");
  const [status, setStatus] = useState("COMPLETED");
  const [payment, setPayment] = useState("");
  const [getBrand, { data: brandData }] = useLazyQuery(GET_BRANDS, { fetchPolicy: "cache-first" });
  const [getCategory, { data: categoryData }] = useLazyQuery(GET_CATEGORYS, { fetchPolicy: "cache-first" });

  useEffect(() => {
    if (categoryData?.categories?.data?.length > 0) {
      const result = categoryData?.categories?.data;
      setCategories(result);
    }
  }, [categoryData]);

  useEffect(() => {
    if (searchCategory === "ALL") return;
    const fetchBrands = async () => {
      try {
        let _where = {
          shop: shopId,
          isDeleted: false
        };
        if (searchCategory !== "ALL") {
          _where = { ..._where, category: searchCategory };
        }
        // TODO: Get all brand
        await getBrand({
          variables: {
            where: _where,
          },
        });
      } catch (error) {
        console.log("Error in fetchBrands:", error);
      }
    };
    fetchBrands();
  }, [searchCategory]);

  const brands = useMemo(() => {
    const result = brandData?.brands?.data
    return result;
  }, [brandData]);

  const [
    LoadReportSumorder,
    { data: getReportSumOrderData, loading: reportSumOrderLoading },
  ] = useLazyQuery(GET_ALL_SUM_ORDER_V2, { fetchPolicy: "cache-and-network" });

  // get data to chart
  const [LoadReportBestSale, { data: getReportBestSaleData, loading: loadingBestSale }] =
    useLazyQuery(GET_REPORT_BEST_SALE_V2, { fetchPolicy: "cache-and-network" });

  const [activeButton, setActiveButton] = useState("thisMonth");
  // states for get by adding date-time

  const [filter, setFilter] = useState({
    createdAt_gte: startDateAndEndDate().startMonth,
    createdAt_lt: startDateAndEndDate().endMonth,
  });
  // ============== > useEffect <==============

  useEffect(() => {
    if (getReportSumOrderData){
      setReportSumAllOrder(getReportSumOrderData?.reportAllSumOrderV2);
      if(categories?.length <= 0) {
        getCategory({
          variables: {
            limit: 100,
            where: {
              shop: shopId,
              isDeleted: false,
            },
          },
        });
      }
    }
  }, [getReportSumOrderData]);

  useEffect(() => {
    if (getReportBestSaleData)
      setReportBestSale(getReportBestSaleData?.reportBestSellerV2?.data);
  }, [getReportBestSaleData]);
  
  useEffect(() => {
    fetchDataReports();
  }, [filter?.createdAt_gte, filter?.createdAt_lt, shopId, searchCategory, searchBrand, status, payment]);

  const fetchDataReports = async () => {
    try {
      if (loadingBestSale || reportSumOrderLoading) return;
      let _where = {
        shop: shopId,
        isDeleted: false,
      };
      if (filter?.createdAt_gte && filter?.createdAt_lt) {
        _where = {
          ..._where,
          createdAt_gte: NewCovertTimeZone(filter?.createdAt_gte),
          createdAt_lt: NewCovertTimeZone(filter?.createdAt_lt)
        };
      }

      if (searchCategory !== "ALL") {
        const category = categories?.find((e) => e?.id === searchCategory);
        _where = {
          ..._where,
          category: category?.id,
          categoryName: category?.name,
        };
      }

      if (searchBrand !== "ALL") {
        const brand = brands?.find((e) => e?.id === searchBrand);
        _where = {
          ..._where,
          brand: brand?.id,
          brandName: brand?.name,
        };
      }

      if (status && status !== "ALL") {
        _where = {
          ..._where,
          status: status,
        };
      }

      if (payment) {
        _where = {
          ..._where,
          payment: payment,
        };
      }

      await Promise.all([
        LoadReportSumorder({
          variables: {
            where: _where,
          },
        }),
        LoadReportBestSale({
          variables: {
            where: _where,
          },
        })
      ]);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  // ============== > fuctions <==============
  let state = {
    series: [
      {
        data: reportBestSale?.map((e) => e?.amount),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      xaxis: {
        categories: reportBestSale?.map((e) => e?.productName),
      },
    },
  };

  // Generate Excel file
  const generateExcel = () => {
    try {
      // Show loading indicator
      const loadingDiv = document.createElement('div');
      loadingDiv.style.position = 'fixed';
      loadingDiv.style.top = '0';
      loadingDiv.style.left = '0';
      loadingDiv.style.width = '100%';
      loadingDiv.style.height = '100%';
      loadingDiv.style.backgroundColor = 'rgba(255, 255, 255, 0.7)';
      loadingDiv.style.display = 'flex';
      loadingDiv.style.justifyContent = 'center';
      loadingDiv.style.alignItems = 'center';
      loadingDiv.style.zIndex = '9999';
      loadingDiv.innerHTML = `
        <div style="text-align: center;">
          <div class="spinner-border text-primary" role="status"></div>
          <p style="margin-top: 10px; font-family: 'Phetsarath', sans-serif;">ກຳລັງສ້າງ Excel...</p>
        </div>
      `;
      document.body.appendChild(loadingDiv);

      // Get shop data
      const shopData = JSON.parse(localStorage.getItem("SHOP_DATA"));
      const shopName = shopData?.name || '4B POS Shop';
      
      // Create workbook
      const wb = XLSX.utils.book_new();
      
      // Format the date range
      const dateRange = `${covertTimeZone(filter?.createdAt_gte)} - ${covertTimeZone(filter?.createdAt_lt)}`;
      
      // Create worksheet for best selling products
      if (reportBestSale && reportBestSale.length > 0) {
        // Prepare headers
        const headers = [
          'ລຳດັບ', // ລຳດັບ
          'ຊື່ສິນຄ້າ', // ຊື່ສິນຄ້າ
          'ປະເພດ', // ປະເພດ
          'ແບຣນ', // ແບຣນ
          'ຫນ່ວຍ', // ຫນ່ວຍ
          'ຈຳນວນ', // ຈຳນວນ
          'ລາຄາ', // ລາຄາ
        ];
        
        // Prepare data rows
        const data = reportBestSale.map((item, index) => [
          index + 1,
          item.productName || '',
          item.category || '',
          item.brand || '',
          item.unit || '',
          item.amount || 0,
          `${numberFormat(item.price ?? 0)} ${convertCurrency(item.currency)}`,
        ]);
        
        // Add title rows
        const titleRows = [
          [shopName, '', '', '', '', '', ''],
          ['ລາຍງານການຂາຍສິນຄ້າ', '', '', '', '', '', ''], // ລາຍງານການຂາຍສິນຄ້າ
          [`ສິນຄ້າຂາຍດີ ${dateRange}`, '', '', '', '', '', ''], // ສິນຄ້າຂາຍດີ
          ['', '', '', '', '', '', ''], // Empty row for spacing
        ];
        
        // Combine all rows
        const allRows = [...titleRows, headers, ...data];
        
        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(allRows);
        
        // Set column widths
        const colWidths = [{ wch: 10 }, { wch: 30 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 20 }];
        ws['!cols'] = colWidths;
        
        // Style the title rows
        ws['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }, // Merge first row (shop name)
          { s: { r: 1, c: 0 }, e: { r: 1, c: 6 } }, // Merge second row (report title)
          { s: { r: 2, c: 0 }, e: { r: 2, c: 6 } }, // Merge third row (date range)
        ];
        
        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'ສິນຄ້າຂາຍດີ'); // ສິນຄ້າຂາຍດີ (Best Selling Products)
      }
      
      // Add summary data worksheet if available
      if (reportSumAllOrder) {
        const summaryData = [
          [shopName, '', ''],
          ['ສະຫລຸບການຂາຍ', '', ''], // ສະຫລຸບການຂາຍ (Sales Summary)
          [`${dateRange}`, '', ''],
          ['', '', ''], // Empty row for spacing
          ['ຈຳນວນບິນ', reportSumAllOrder.billAmount ?? 0, ''], // ຈຳນວນບິນ (Bill Count)
          ['ສິນຄ້າທັງຫມົດ', reportSumAllOrder.productAmount ?? 0, ''], // ສິນຄ້າທັງຫມົດ (Total Products)
          ['ຍອດຂາຍທັງຫມົດ (LAK)', numberFormat(reportSumAllOrder.totalPrice ?? 0), ''], // ຍອດຂາຍທັງຫມົດ (Total Sales LAK)
          ['ຍອດຂາຍທັງຫມົດ (THB)', numberFormat(reportSumAllOrder.sumPriceBaht ?? 0), ''], // ຍອດຂາຍທັງຫມົດ (Total Sales THB)
          ['ຍອດຂາຍທັງຫມົດ (USD)', numberFormat(reportSumAllOrder.sumPriceUsd ?? 0), ''], // ຍອດຂາຍທັງຫມົດ (Total Sales USD)
        ];
        
        // Create worksheet
        const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
        
        // Set column widths
        wsSummary['!cols'] = [{ wch: 30 }, { wch: 20 }, { wch: 10 }];
        
        // Style the title rows
        wsSummary['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }, // Merge first row (shop name)
          { s: { r: 1, c: 0 }, e: { r: 1, c: 2 } }, // Merge second row (summary title)
          { s: { r: 2, c: 0 }, e: { r: 2, c: 2 } }, // Merge third row (date range)
        ];
        
        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, wsSummary, 'ສະຫລຸບການຂາຍ'); // ສະຫລຸບການຂາຍ (Sales Summary)
      }
      
      // Generate Excel file
      XLSX.writeFile(wb, `4B_POS_Report_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`);
      
      // Remove loading indicator
      document.body.removeChild(loadingDiv);
      
    } catch (error) {
      console.error('Error generating Excel:', error);
      alert('ເກີດຂໍ້ຜິດພາດໃນການສ້າງ Excel. ກະລຸນາລອງໃໝ່ອີກຄັ້ງ.');
      
      // Make sure to remove loading indicator in case of error
      const loadingDiv = document.querySelector('div[style*="position: fixed"][style*="z-index: 9999"]');
      if (loadingDiv) {
        document.body.removeChild(loadingDiv);
      }
    }
  };
  
  // download to pdf file
  const generatePdf = () => {
    try {
      console.log('Starting PDF generation...');
      
      // Show loading indicator
      const loadingDiv = document.createElement('div');
      loadingDiv.style.position = 'fixed';
      loadingDiv.style.top = '0';
      loadingDiv.style.left = '0';
      loadingDiv.style.width = '100%';
      loadingDiv.style.height = '100%';
      loadingDiv.style.backgroundColor = 'rgba(255, 255, 255, 0.7)';
      loadingDiv.style.display = 'flex';
      loadingDiv.style.justifyContent = 'center';
      loadingDiv.style.alignItems = 'center';
      loadingDiv.style.zIndex = '9999';
      loadingDiv.innerHTML = `
        <div style="text-align: center;">
          <div class="spinner-border text-primary" role="status"></div>
          <p style="margin-top: 10px; font-family: 'Phetsarath', sans-serif;">ກຳລັງສ້າງ PDF...</p>
        </div>
      `;
      document.body.appendChild(loadingDiv);

      // Get shop data
      const shopData = JSON.parse(localStorage.getItem("SHOP_DATA"));
      const shopName = shopData?.name || '4B POS Shop';
      
      // Create PDF document
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });
      
      const pageWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const margin = 10; // margin in mm
      const contentWidth = pageWidth - (margin * 2);
      
      // Get the chart and table elements
      const chartElement = document.querySelector('div[style="width: 100%; margin-bottom: 10px;"] .card');
      const tableElement = document.querySelector('div[style="width: 100%; margin-bottom: 20px;"] .card');
      
      if (!chartElement || !tableElement) {
        console.error('Could not find chart or table elements');
        document.body.removeChild(loadingDiv);
        alert('ບໍ່ສາມາດຊອກຫາຂໍ້ມູນສຳລັບການສ້າງ PDF. ກະລຸນາລອງໃໝ່ອີກຄັ້ງ.');
        return;
      }
      
      // Create a header canvas to handle Lao text properly
      const createHeaderCanvas = () => {
        const canvas = document.createElement('canvas');
        canvas.width = 800;
        canvas.height = 100;
        const ctx = canvas.getContext('2d');
        
        // Fill background
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Add title
        ctx.font = 'bold 24px Phetsarath, Noto Sans Lao, Arial, sans-serif';
        ctx.fillStyle = '#3C169B';
        ctx.textAlign = 'center';
        ctx.fillText('ລາຍງານການຂາຍສິນຄ້າ', canvas.width / 2, 35);
        
        // Add shop name and date
        ctx.font = '14px Phetsarath, Noto Sans Lao, Arial, sans-serif';
        ctx.fillStyle = '#333333';
        ctx.textAlign = 'left';
        ctx.fillText(shopName, 50, 70);
        
        ctx.textAlign = 'right';
        // ctx.fillText(`ສິນຄ້າຂາຍດີ ${ConvertDay(activeButton)}`, canvas.width - 50, 70);
        ctx.fillText(`ສິນຄ້າຂາຍດີ ${filter?.createdAt_gte} - ${filter?.createdAt_lt}`, canvas.width - 50, 70);
        
        // Add a line
        ctx.strokeStyle = '#3C169B';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(50, 85);
        ctx.lineTo(canvas.width - 50, 85);
        ctx.stroke();
        
        return canvas;
      };
      
      // Function to add header to a page
      const addHeader = (pageNum) => {
        const headerCanvas = createHeaderCanvas();
        const headerImgData = headerCanvas.toDataURL('image/png');
        pdf.addImage(headerImgData, 'PNG', margin, margin, contentWidth, 25);
      };
      
      // Function to create page number canvas
      const createPageNumberCanvas = (pageNum, totalPages) => {
        const canvas = document.createElement('canvas');
        canvas.width = 200;
        canvas.height = 30;
        const ctx = canvas.getContext('2d');
        
        // Fill background
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Add page number text
        ctx.font = '12px Phetsarath, Noto Sans Lao, Arial, sans-serif';
        ctx.fillStyle = '#666666';
        ctx.textAlign = 'center';
        ctx.fillText(`ໜ້າ ${pageNum} ຂອງ ${totalPages}`, canvas.width / 2, 15);
        
        return canvas;
      };
      
      // Function to add page number
      const addPageNumber = (pageNum, totalPages) => {
        const pageNumberCanvas = createPageNumberCanvas(pageNum, totalPages);
        const pageNumberImgData = pageNumberCanvas.toDataURL('image/png');
        // Position the page number at the bottom center
        const pageNumberWidth = 40; // mm
        pdf.addImage(
          pageNumberImgData, 
          'PNG', 
          (pageWidth - pageNumberWidth) / 2, 
          pageHeight - 10, 
          pageNumberWidth, 
          5
        );
      };
      
      // Capture the chart
      html2canvas(chartElement, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff'
      }).then(chartCanvas => {
        // Add header to first page
        addHeader(1);
        
        // Add chart to first page
        const chartImgData = chartCanvas.toDataURL('image/png');
        const chartHeight = (chartCanvas.height * contentWidth) / chartCanvas.width;
        pdf.addImage(chartImgData, 'PNG', margin, margin + 30, contentWidth, chartHeight);
        
        // Capture the table
        return html2canvas(tableElement, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff'
        });
      }).then(tableCanvas => {
        // Add new page for table
        pdf.addPage();
        
        // Add header to second page
        addHeader(2);
        
        // Add table to second page
        const tableImgData = tableCanvas.toDataURL('image/png');
        const tableHeight = (tableCanvas.height * contentWidth) / tableCanvas.width;
        pdf.addImage(tableImgData, 'PNG', margin, margin + 30, contentWidth, tableHeight);
        
        // Add page numbers
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          addPageNumber(i, totalPages);
        }
        
        // Save PDF
        pdf.save('4B_POS_Report.pdf');
        
        // Remove loading indicator
        document.body.removeChild(loadingDiv);
      }).catch(error => {
        console.error('Error generating PDF:', error);
        document.body.removeChild(loadingDiv);
        alert('ເກີດຂໍ້ຜິດພາດໃນການສ້າງ PDF. ກະລຸນາລອງໃໝ່ອີກຄັ້ງ.');
      });
    } catch (error) {
      console.error('Error in generatePdf:', error);
      alert('ເກີດຂໍ້ຜິດພາດໃນການສ້າງ PDF. ກະລຸນາລອງໃໝ່ອີກຄັ້ງ.');
    }
  };

  return (
    <NavDashboard title="ຍອດຂາຍລວມວັນນີ້">
      <Card className="dashboard-header" style={{ marginBottom: "10px" }}>
        <Card.Body>
          <Row>
            {/* Date Filter */}
            <Col xs={12} md={2}>
              <Form.Group>
                <Form.Label className="filter-label">ວັນທີ, ເດືອນ, ປີ</Form.Label>
                <Button
                  variant="outline-secondary"
                  onClick={() => setIsCurrentModals(true)}
                  style={{ textAlign: "left", marginTop: '-.2em', width: '100%' }}
                >
                  {(reportSumOrderLoading && !getReportSumOrderData) ? (
                    <Spinner size="sm" />
                  ) : (
                    <MdOutlineDateRange className="icon" />
                  )}
                  <span className="date-text">
                    {!filter ? "mm/dd/yyyy" : (
                      `${covertTimeZone(filter?.createdAt_gte)} ຫາ ${covertTimeZone(filter?.createdAt_lt)}`
                    )}
                  </span>
                </Button>
              </Form.Group>

              <CurrentDateComponents
                onCloseModal={() => setIsCurrentModals(false)}
                openModal={isCurrentModals}
                setCdFillter={setFilter}
                setActiveButton={setActiveButton}
                activeButton={activeButton}
              />
            </Col>

            {/* Filters Row */}
            <Col xs={12} md={2} className="mb-3">
              <Form.Group>
                <Form.Label className="filter-label">ປະເພດ</Form.Label>
                <Form.Select
                  className="filter-select"
                  onChange={(e) => setSearchCategory(e?.target?.value)}
                  value={searchCategory}
                >
                  <option value="ALL">--ເລືອກ--</option>
                  {categories?.length > 0 && categories?.map((category, _index) => (
                    <option key={_index} value={category?.id}>
                      {category?.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col xs={12} md={2} className="mb-3">
              <Form.Group>
                <Form.Label className="filter-label">ແບຣນ</Form.Label>
                <Form.Select
                  className="filter-select"
                  onChange={(e) => setSearchBrand(e?.target?.value)}
                  value={searchBrand}
                >
                  <option value="ALL">--ເລືອກ--</option>
                  {brands?.length > 0 && brands?.map((brand, _index) => (
                    <option key={_index} value={brand?.id}>
                      {brand?.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* //TODO: Payment Filter */}
            <Col xs={12} md={2} className="mb-3">
              <Form.Group>
                <Form.Label className="filter-label">ສະຖານະ</Form.Label>
                <Form.Select
                  className="filter-select action-select"
                  onChange={(e) => {
                    const action = e.target.value;
                    setStatus(action);
                  }}
                  defaultValue={status}
                >
                  <option value="ALL">--ເລືອກທັງຫມົດ--</option>
                  <option value="COMPLETED">ຊຳລະແລ້ວ</option>
                  <option value="INDEBTED">ຕີດຫນີ້</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col xs={12} md={2} className="mb-3">
              <Form.Group>
                <Form.Label className="filter-label">ປະເພດຊຳລະ</Form.Label>
                <Form.Select
                  className="filter-select"
                  onChange={(e) => setPayment(e?.target?.value)}
                  value={payment}
                >
                  <option value="">--ເລືອກ--</option>
                  <option value="CASH">ເງິນສົດ</option>
                  <option value="TRANSFER">ເງິນໂອນ</option>
                </Form.Select>
              </Form.Group>
            </Col>
            
            <Col xs={12} md={2} className="mb-3">
              <Form.Group>
                <Form.Label className="filter-label">ການດຳເນີນການ</Form.Label>
                <Form.Select
                  className="filter-select action-select"
                  onChange={(e) => {
                    const action = e.target.value;
                    if (action === "pdf") {
                      generatePdf();
                    } else if (action === "excel") {
                      generateExcel();
                    } else if (action === "print_A4") {
                      document.getElementById("print-button").click();
                    }
                    // Reset select after action
                    setTimeout(() => {
                      e.target.value = "";
                    }, 500);
                  }}
                  defaultValue=""
                >
                  <option value="" disabled>--ເລືອກການດຳເນີນການ--</option>
                  <option value="excel">ດາວໂຫລດ Excel</option>
                  <option value="pdf">ດາວໂຫລດ PDF</option>
                  <option value="print_A4">ພິມເປັນ A4</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          
          {/* Hidden Print Trigger */}
          <div style={{ display: 'none' }}>
            <ReactToPrint
              trigger={() => (
                <button id="print-button">Print</button>
              )}
              content={() => printRef.current}
            />
          </div>
        </Card.Body>
      </Card>

      <div style={{ padding: 0 }} ref={printRef}>
        <Row className="mb-4">
          {/* Bill Count Card */}
          <Col lg={4} md={6} sm={12} className="mb-3">
            <Card className="stat-card shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="stat-icon bill-icon me-3">
                    <AiOutlineFileText size={24} />
                  </div>
                  <div className="stat-info">
                    <h6 className="stat-title mb-1">ຈຳນວນບິນ</h6>
                    <h3 className="stat-value mb-0">{reportSumAllOrder?.billAmount ?? 0}</h3>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
          {/* Product Count Card */}
          <Col lg={4} md={6} sm={12} className="mb-3">
            <Card className="stat-card shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="stat-icon product-icon me-3">
                    <AiOutlinePieChart size={24} />
                  </div>
                  <div className="stat-info">
                    <h6 className="stat-title mb-1">ສິນຄ້າທັງຫມົດ</h6>
                    <h3 className="stat-value mb-0">{reportSumAllOrder?.productAmount ?? 0}</h3>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
          {/* Sales Total Card */}
          <Col lg={4} md={12} sm={12} className="mb-3">
            <Card className="stat-card shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-start">
                  <div className="stat-icon money-icon me-3">
                    <RiMoneyDollarCircleLine size={24} />
                  </div>
                  <div className="stat-info">
                    <h6 className="stat-title mb-2">ຍອດຂາຍທັງຫມົດ</h6>
                    <div className="currency-values">
                      <div className="d-flex align-items-center mb-1">
                        <span className="currency-symbol me-2">₭</span>
                        <span className="currency-amount">{numberFormat((reportSumAllOrder?.totalPrice ?? 0) - (reportSumAllOrder?.discount ?? 0))}</span>
                      </div>
                      {
                        reportSumAllOrder?.sumPriceBaht > 0 && 
                        <div className="d-flex align-items-center mb-1">
                          <span className="currency-symbol me-2">฿</span>
                          <span className="currency-amount">{numberFormat(reportSumAllOrder?.sumPriceBaht ?? 0)}</span>
                        </div>
                      }
                      {
                        reportSumAllOrder?.sumPriceUsd > 0 && 
                        <div className="d-flex align-items-center">
                          <span className="currency-symbol me-2">$</span>
                          <span className="currency-amount">{numberFormat(reportSumAllOrder?.sumPriceUsd ?? 0)}</span>
                        </div>
                      }
                      {
                        reportSumAllOrder?.discount > 0 && 
                        <div className="d-flex align-items-center">
                          <span className="stat-title mb-1"> ສ່ວນຫລຸດ:{" "}{numberFormat(reportSumAllOrder?.discount ?? 0)} ₭</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Chart Section */}
        <div style={{ width: "100%", marginBottom: "10px" }}>
          <Card className="shadow-sm">
            <Card.Body>
              <h5 className="mb-3">ສິນຄ້າຂາຍດີ</h5>
              <ReactApexChart
                options={state.options}
                series={state.series}
                type="bar"
                height={400}
              />
            </Card.Body>
          </Card>
        </div>

        {/* Best Sellers Table */}
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <Card className="shadow-sm">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">ລາຍງານການຂາຍສິນຄ້າ</h5>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <span className="report-title">
                  <LocalActivityIcon
                    sx={{
                      color: "#3C169B",
                      marginRight: "8px",
                      verticalAlign: "middle"
                    }}
                  />
                  ສິນຄ້າຂາຍດີ {ConvertDay(activeButton)}
                </span>
              </div>
              {(reportSumOrderLoading && !getReportSumOrderData) ? (
                <AnimationLoading />
              ) : (
                <Table striped hover responsive>
                  <thead className="table-header">
                    <tr>
                      <th>ລຳດັບ</th>
                      <th>ຊື່ສິນຄ້າ</th>
                      <th>ປະເພດ</th>
                      <th>ແບຣນ</th>
                      <th>ຫນ່ວຍ</th>
                      <th>ຈຳນວນ</th>
                      <th>ລາຄາ</th>
                    </tr>
                  </thead>

                  {reportBestSale.length > 0 ? (
                    <tbody>
                      {reportBestSale?.map((data, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data?.productName}</td>
                          <td>{data?.category}</td>
                          <td>{data?.brand}</td>
                          <td>{data?.unit}</td>
                          <td>{data?.amount}</td>
                          <td>{numberFormat(data?.price ?? 0)} {convertCurrency(data?.currency)}</td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={5}>
                          <div className="empty-state">
                            <EmptyComponent />
                            <p>ຍັງບໍ່ມີລາຍການສິນຄ້າ!!!</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </NavDashboard>
  );
}

export default Dashboard;
